import nl from 'flagpack-core/svg/m/NL.svg';
import en from 'flagpack-core/svg/m/GB-UKM.svg';

const getCountryUri = code => {
    if (code === 'en') {
        return en;
    } else if (code === 'nl') {
        return nl;
    }
}

const getCountryIcon = (code) => {
    const img = document.createElement("img");
    img.src = getCountryUri(code);

    return img;
}

export {
    getCountryIcon
}